import { derived } from 'svelte/store';
import { modulesAccess } from './modulesAccess';

export const productImportAccess = derived(modulesAccess, ($access) =>
  $access.productImport ?? { canAccessModule: false, canRunBulkImport: false, effectivePermissions: [] }
);
